"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function sanitizeCheckedContent(checkedContent) {
    return {
        modules: checkedContent.modules || [],
        pages: checkedContent.pages || [],
        nPublished: checkedContent.nPublished || 0,
        nUnpublished: checkedContent.nUnpublished || 0
    };
}
function sanitizeModules(modules) {
    return ((modules === null || modules === void 0 ? void 0 : modules.map((module) => ({
        id: module.id || '0',
        totalPages: module.totalPages || 0,
        pages: module.pages || []
    }))) || []);
}
const useCheckedContentChange = () => {
    return (0, react_1.useCallback)((_checkedContent, _modules) => {
        const checkedContent = sanitizeCheckedContent(_checkedContent);
        const modules = sanitizeModules(_modules);
        function countNotLoadedPages() {
            return modules.reduce((accumulator, module) => {
                const moduleIsChecked = checkedContent.modules.includes(module.id);
                const pagesAreLoaded = module.totalPages > 0 && module.pages.length > 0;
                return (accumulator +
                    (moduleIsChecked && !pagesAreLoaded ? module.totalPages : 0));
            }, 0);
        }
        function count() {
            return (checkedContent.modules.length +
                checkedContent.pages.length +
                countNotLoadedPages());
        }
        window.dispatchEvent(new CustomEvent('modulelistselecteditemschange', {
            detail: {
                modules: checkedContent.modules,
                pages: checkedContent.pages,
                total: count(),
                publishedCount: checkedContent.nPublished,
                unpublishedCount: checkedContent.nUnpublished
            }
        }));
    }, []);
};
exports.default = useCheckedContentChange;
